module.exports = __webpack_public_path__ + "static/Mumbai-4dd21d64a8dd7de774cd62bada266c7f.png";